
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Buscar",
      function () {
        return require("private-next-pages/Buscar/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Buscar"])
      });
    }
  